export enum UserRole {
	Admin = 'Admin',
	Manager = 'Manager',
	Operator = 'Operator',
	Observer = 'Observer',
	SuperAdmin = 'SuperAdmin'
}
